import React from 'react';
import Header from './header';
import Footer from './footer';
import '../../styles/layout.css';
import { content, darkContent } from './layout.module.css';
import { cn } from '../../lib/helpers';

// enable for mobile debugging on a preview/staging branch shows logs in a console window in app
// import { LogsContainer } from '../../utils/logs-container';

import { createTheme, ThemeProvider } from '@mui/material';
import { Helmet } from 'react-helmet';

const theme = createTheme({
  components: {
    // Name of the component ⚛️
    MuiButtonBase: {
      defaultProps: {
        // The props to apply
        disableRipple: true, // No more ripple, on the whole application 💣!
      },
    },
  },
});

const Layout = ({ children, siteTitle, siteSubtitle, siteSetting, dark = false }) => (
  <ThemeProvider theme={theme}>
    <Helmet>
      <script type="text/javascript" async={true} src="https://secure.agile-company-247.com/js/261915.js" />
      <script type="text/javascript">
        {`
        function track_load (docloc, doctit) {
var trk_sw = escape(screen.width).substring(0, 6);
var trk_sh = escape(screen.height).substring(0, 6);
var trk_ref = escape(document.referrer).substring(0, 1100);
var trk_tit = escape(doctit).substring(0, 200);
trk_tit = trk_tit.replace(/\\%u00a0/g, '');
trk_tit = trk_tit.replace(/\\%u2122/g, '');
trk_tit = trk_tit.replace(/\\%u[0-9][0-9][0-9][0-9]/g, '');
var trk_loc = escape(docloc).substring(0, 200);
var trk_agn = escape(navigator.appName).substring(0, 100);
var trk_lng = window.navigator.userLanguage || window.navigator.language;
var trk_agv = escape(navigator.userAgent + '.lfcd' + screen.colorDepth + '.lflng' + trk_lng).substring(0, 1000);
var trk_dom = escape(document.domain).substring(0, 200);
var trk_user = '261915';
var trk_cookie = '';
var trk_guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
return v.toString(16);
});
var trk_img = 'https://secure.leadforensics.com/Track/Capture.aspx';
var trk_link = trk_img + '?trk_user=' + trk_user + '&trk_sw=' + trk_sw + '&trk_sh=' + trk_sh + '&trk_ref=' + trk_ref + '&trk_tit=' + trk_tit + '&trk_loc=' + trk_loc + '&trk_agn=' + trk_agn + '&trk_agv=' + trk_agv + '&trk_dom=' + trk_dom + '&trk_guid=' + trk_guid + '&trk_cookie=NA';
var preload = new Image();
preload.src = trk_link;
}
         `}
      </script>
      <noscript
        dangerouslySetInnerHTML={{
          __html: `<img alt="" src="https://secure.agile-company-247.com/261915.png" style="display:none;" />`,
        }}
      />
    </Helmet>
    <Header siteTitle={siteTitle} siteSubtitle={siteSubtitle} siteSetting={siteSetting} />
    <main className={cn(content, dark ? darkContent : '')}>{children}</main>
    <Footer />
    {/*<LogsContainer />*/}
  </ThemeProvider>
);

export default Layout;
